import script from "./PreSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsFixtureBook.vue?vue&type=style&index=0&id=6b4f4e6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4f4e6d"]])

export default __exports__